<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div [ngClass]="getTopClass()">
  <iframe
    title="focused app"
    allow="fullscreen"
    class="focused-app-iframe"
    [src]="safeUrl"
    aria-label="Focused Application"
  ></iframe>
</div>
